const gjxx = {
  namespaced: true,
  state: {
    otherObj: {},
    listObj: {},

  },
  getters: {
    otherObj: (state) => state.otherObj,
    listObj: (state) => state.listObj,
  },
  mutations: {
    updateData(state, data) {
      for (const key in data) {
        state[key] = data[key];
      }
    },
  },
  actions: {},
};
export default gjxx;
